module.exports = __webpack_public_path__ + "static/media/Saurabh.f8e410aa.svg";